/** Product feature toggles — flip on when a capability ships. */
export const TEAM_INVITES_UI_ENABLED = false;

/** Onboarding steps 8–12: Reddit, Quora, voice fingerprint, import data, briefing preferences. */
export const ONBOARDING_EXTENDED_STEPS_ENABLED = false;

/** Brain: KPI tiles, sync all, documents tab, voice memos nav, advanced memory settings. */
export const BRAIN_EXTENDED_FEATURES_ENABLED = false;

/** Today: Coming next footer and Window overnight pulse tile. */
export const TODAY_EXTENDED_FEATURES_ENABLED = false;

/** Content module: calendar, studio, queue, library, brand voice, distribution. */
export const CONTENT_ENABLED = false;

/** Settings: extended tabs, persona sections, team security/role guide, Reddit/Quora connections. */
export const SETTINGS_EXTENDED_FEATURES_ENABLED = false;
